// src/pages/leads/CancelModal.jsx
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  Box,
  Text,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Select,
  Textarea,
} from '@chakra-ui/react';

/**
 * CancelModal
 *
 * Props:
 * - isOpen: boolean
 * - onClose: () => void
 * - cancelType: 'appointment' | 'sale'
 * - saleReasons: string[]               // for 'sale' only (preset list)
 * - reasonPreset: string                // for 'sale'
 * - onChangeReasonPreset: (v: string) => void
 * - reasonText: string                  // free text (required for 'appointment'; required when sale->Other)
 * - onChangeReasonText: (v: string) => void
 * - onSubmit: () => void
 * - submitting: boolean
 */
export default function CancelModal({
  isOpen,
  onClose,
  cancelType = 'appointment',
  saleReasons = [],
  reasonPreset = '',
  onChangeReasonPreset,
  reasonText = '',
  onChangeReasonText,
  onSubmit,
  submitting = false,
}) {
  const isSale = cancelType === 'sale';

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{isSale ? 'Cancel Sale' : 'Cancel Appointment'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            {isSale ? (
              <>
                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold" color="gray.600">
                    Reason (preset)
                  </FormLabel>
                  <Select
                    size="lg"
                    placeholder="Select reason"
                    value={reasonPreset}
                    onChange={(e) => onChangeReasonPreset?.(e.target.value)}
                  >
                    {saleReasons.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {reasonPreset === 'Other' && (
                  <FormControl isRequired>
                    <FormLabel fontSize="sm" fontWeight="bold" color="gray.600">
                      Reason (free text)
                    </FormLabel>
                    <Textarea
                      value={reasonText}
                      onChange={(e) => onChangeReasonText?.(e.target.value)}
                      placeholder="Type the reason…"
                    />
                  </FormControl>
                )}
              </>
            ) : (
              <FormControl isRequired>
                <FormLabel fontSize="sm" fontWeight="bold" color="gray.600">
                  Notes / reason
                </FormLabel>
                <Textarea
                  value={reasonText}
                  onChange={(e) => onChangeReasonText?.(e.target.value)}
                  placeholder="Type why the appointment is cancelled…"
                />
              </FormControl>
            )}
          </VStack>

          <Box mt={6} p={3} bg="gray.50" borderRadius="md">
            <Text fontSize="sm" color="gray.700">
              • Appointment cancel → lead becomes <b>CPTA</b> and is <b>unassigned</b>.<br />• Sale
              cancel → lead becomes <b>ARCHIVE_DNC</b> (Do Not Contact).
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Flex justify="flex-end" pt={4} w="100%">
            <Button variant="ghost" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button colorScheme="red" onClick={onSubmit} isLoading={submitting}>
              Confirm Cancel
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
